// jQuery(window).load(function () {
// 	jQuery("body").removeClass("loading");
// });

window.addEventListener("beforeunload", function (event) {
	jQuery("body").addClass("loading");
});
